import { ComingSoonEmptyState } from '../shell/empty-states/coming-soon-empty-state.js';

export function OverviewPage(): JSX.Element {
  return (
    <ComingSoonEmptyState
      title="Overview"
      description="A daily snapshot of what your community is saying, what's tracking against the current milestone, and where attention is needed. Lands with the Overview epic."
    />
  );
}
